function closeHeaderNavDropdowns(exceptItem) {
  document.querySelectorAll("[data-header-nav-dropdown].is-open").forEach((item) => {
    if (item === exceptItem) return;
    item.classList.remove("is-open");
    const toggle = item.querySelector(".baxter-header__nav-dropdown-toggle");
    if (toggle) toggle.setAttribute("aria-expanded", "false");
  });
}

function initHeaderNavDropdowns() {
  const items = document.querySelectorAll("[data-header-nav-dropdown]");
  if (!items.length) return;

  items.forEach((item) => {
    const toggle = item.querySelector(".baxter-header__nav-dropdown-toggle");
    if (!toggle) return;

    toggle.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const willOpen = !item.classList.contains("is-open");
      closeHeaderNavDropdowns(willOpen ? item : null);
      item.classList.toggle("is-open", willOpen);
      toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-header-nav-dropdown]")) return;
    closeHeaderNavDropdowns();
  });
}

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;

  closeHeaderNavDropdowns();

  document.querySelectorAll(".baxter-header__mobile-menu[open]").forEach((menu) => {
    menu.removeAttribute("open");
  });
});

document.addEventListener("click", (event) => {
  const link = event.target.closest(".baxter-header__mobile-link");
  if (!link) return;

  const menu = link.closest(".baxter-header__mobile-menu");
  if (menu) menu.removeAttribute("open");
});

function initStickyHeader() {
  const header = document.querySelector("[data-baxter-sticky-header]");
  if (!header) return;

  const root = header.closest(".section-baxter-header") || header;
  let animationFrame = null;

  const updateScrolledState = () => {
    animationFrame = null;
    const isScrolled = window.scrollY > 4;
    root.classList.toggle("is-scrolled", isScrolled);
    header.classList.toggle("is-scrolled", isScrolled);
  };

  const requestScrolledState = () => {
    if (animationFrame) return;
    animationFrame = window.requestAnimationFrame(updateScrolledState);
  };

  const updateHeaderHeight = () => {
    document.documentElement.style.setProperty("--bd-sticky-header-height", `${root.offsetHeight}px`);
  };

  updateHeaderHeight();
  requestScrolledState();

  window.addEventListener("scroll", requestScrolledState, { passive: true });
  window.addEventListener("resize", updateHeaderHeight);

  if ("ResizeObserver" in window) {
    const observer = new ResizeObserver(updateHeaderHeight);
    observer.observe(root);
  }
}

function getCartAddUrl() {
  const root = window.Shopify?.routes?.root || "/";
  return `${root}cart/add.js`;
}

async function addVariantToCart(variantId, quantity = 1) {
  const response = await fetch(getCartAddUrl(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      items: [{ id: Number(variantId), quantity }],
    }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.description || "Could not add to cart.");
  }

  return response.json();
}

function updateCartCount(count) {
  document.querySelectorAll(".baxter-header__cart-count").forEach((node) => {
    node.textContent = String(count);
  });
}

function initBundleAjaxCart() {
  document.querySelectorAll(".baxter-bundle-add-to-cart").forEach((button) => {
    button.addEventListener("click", async () => {
      const variantId = button.dataset.variantId;
      if (!variantId || button.disabled) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = "Adding…";

      try {
        await addVariantToCart(variantId);
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`);
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          updateCartCount(cart.item_count);
        }
        button.textContent = "Added ✓";
        window.setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1800);
      } catch (error) {
        button.textContent = "Try again";
        window.setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
        window.alert(error.message);
      }
    });
  });
}

function initStickyProductAtc() {
  const section = document.querySelector("[data-baxter-product-main]");
  const form = document.getElementById("BaxterProductForm");
  const sticky = document.getElementById("BaxterStickyAtc");
  const submitButton = form?.querySelector("[data-baxter-add-to-cart]");
  const stickySubmit = sticky?.querySelector("[data-baxter-sticky-submit]");

  if (!section || !form || !sticky || !submitButton || !stickySubmit) return;

  const mobileQuery = window.matchMedia("(max-width: 749px)");

  const toggleSticky = (show) => {
    sticky.hidden = !show || !mobileQuery.matches;
  };

  const observer = new IntersectionObserver(
    ([entry]) => {
      toggleSticky(!entry.isIntersecting);
    },
    { threshold: 0, rootMargin: "0px 0px -1px 0px" }
  );

  observer.observe(submitButton);

  mobileQuery.addEventListener("change", () => {
    if (!mobileQuery.matches) sticky.hidden = true;
  });

  stickySubmit.addEventListener("click", () => {
    submitButton.click();
    submitButton.scrollIntoView({ behavior: "smooth", block: "center" });
  });

  const variantSelect = form.querySelector("[data-baxter-variant-select]");
  const priceNode = document.querySelector("[data-baxter-sticky-price]");
  const mainPrice = document.querySelector("[data-baxter-price]");

  if (variantSelect && priceNode) {
    variantSelect.addEventListener("change", () => {
      const option = variantSelect.selectedOptions[0];
      if (!option) return;
      const price = option.dataset.price;
      if (price) priceNode.textContent = price;
      if (mainPrice && price) mainPrice.textContent = price;
    });
  }
}


function initEducatorGradeLanguageFilter() {
  const root = document.querySelector("[data-educator-grade-collection]");
  if (!root) return;

  const buttons = root.querySelectorAll("[data-lang-filter]");
  const cards = root.querySelectorAll("[data-educator-product-card]");
  const emptyMessage = root.querySelector("[data-educator-filter-empty]");
  if (!buttons.length || !cards.length) return;

  const normalizeTag = (value) => String(value || "").trim();

  const productTags = (card) => {
    try {
      return JSON.parse(card.dataset.productTags || "[]").map(normalizeTag);
    } catch {
      return String(card.dataset.productTags || "")
        .split(",")
        .map(normalizeTag)
        .filter(Boolean);
    }
  };

  const applyLanguage = (language) => {
    let visibleCount = 0;

    cards.forEach((card) => {
      const tags = productTags(card);
      const show =
        tags.includes(language) ||
        (language === "Español" && (tags.includes("Spanish") || tags.includes("Espanol")));
      card.hidden = !show;
      if (show) visibleCount += 1;
    });

    if (emptyMessage) {
      emptyMessage.hidden = visibleCount > 0;
    }
  };

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const language = button.dataset.langFilter;
      buttons.forEach((btn) => {
        const active = btn === button;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
      applyLanguage(language);
    });
  });

  applyLanguage("English");
}

function initStoryReveal() {
  const nodes = document.querySelectorAll("[data-story-reveal]");
  if (!nodes.length) return;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    nodes.forEach((node) => node.classList.add("is-visible"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        obs.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
  );

  nodes.forEach((node) => observer.observe(node));
}

document.addEventListener("DOMContentLoaded", () => {
  initStickyHeader();
  initHeaderNavDropdowns();
  initBundleAjaxCart();
  initStickyProductAtc();
  initEducatorGradeLanguageFilter();
  initStoryReveal();
});
